export default __webpack_public_path__ + "assets/images/705fe9dc487903f1a8db028e02aefef1.jpg";